var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import styled, { withTheme } from 'styled-components';
import { rem } from '../utils/Polished';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import Typography from '../Typography/Typography';
import Link from '../Link';
const ToastSC = styled.div `
  width: ${(p) => p.theme.SizeWidthToastBase};
  box-sizing: border-box;
  border-radius: ${(p) => p.theme.SizeBorderRadiusToastBase};

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: ${(p) => (p.inline ? 'unset' : 'wrap')};

  position: absolute;
  left: 50%;
  top: ${rem('16px')};

  z-index: ${(p) => p.theme.zIndex.topLayer};

  transform: translateX(-50%);

  padding: ${(p) => p.theme.SizePaddingToastBase};

  background-color: ${(p) => p.theme.ColorBackgroundGreyDark2};
  box-shadow: ${(p) => p.theme.SizeShadowToastBase}
    ${(p) => p.theme.ColorShadowToastBase};

  will-change: top;
  transition: top 0.3s ease-in-out;

  & svg {
    margin-right: ${rem('8px')};
    flex: none;
  }

  & ._ndsToast__content {
    max-width: ${rem('272px')};
    max-height: ${rem('40px')};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & div a {
    max-width: ${rem('304px')};
    max-height: ${rem('20px')};
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
  }
`;
class Toast extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isIn: false
        };
        this.startDismissTimer = () => {
            clearTimeout(this.dismissTimer);
            this.dismissTimer = setTimeout(() => this.setState({
                isIn: false
            }), 4000);
        };
        this.onEntered = () => {
            this.startDismissTimer();
        };
        this.clickAction = (event) => {
            const { onAction } = this.props;
            if (onAction !== undefined) {
                onAction(event);
            }
        };
    }
    componentDidMount() {
        this.delayedStartTimer = setTimeout(() => {
            this.setState({ isIn: true });
        }, 300);
    }
    componentDidUpdate(_prevProps, prevState) {
        const { isIn } = this.state;
        if (prevState.isIn && isIn) {
            this.startDismissTimer();
        }
    }
    componentWillUnmount() {
        clearTimeout(this.delayedStartTimer);
    }
    render() {
        const _a = this.props, { message, action, inline, icon, type, theme, onAction, forwardedRef } = _a, others = __rest(_a, ["message", "action", "inline", "icon", "type", "theme", "onAction", "forwardedRef"]);
        const { isIn } = this.state;
        const { clickAction } = this;
        const renderText = (React.createElement(Typography, { mode: "dark", variant: "body3", className: "_ndsToast__content" }, message));
        let contentRow = null;
        if (icon) {
            const iconColor = {
                success: '#3fc078',
                alert: '#f43e6d',
                info: '#a3c2f5'
            };
            let iconComp = null;
            if (React.isValidElement(icon)) {
                iconComp = React.cloneElement(icon, {
                    color: iconColor[type]
                });
            }
            contentRow = (React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center'
                } },
                iconComp,
                renderText));
        }
        else {
            contentRow = renderText;
        }
        const renderAction = action ? (React.createElement(Link, { mode: "dark", onClick: clickAction }, action)) : null;
        const actionRow = inline ? (renderAction) : (React.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: rem('8px')
            } }, renderAction));
        const defaultStyle = {
            willChange: 'top',
            transition: `top 0.3s ease-in-out`,
            position: 'fixed',
            top: rem('-120px'),
            left: '50%',
            zIndex: theme.zIndex.topLayer
        };
        const transitionStyles = {
            entering: { top: '0' },
            entered: { top: '0' },
            exiting: { top: rem('-120px') },
            exited: { top: rem('-120px') }
        };
        return (React.createElement(Transition, { in: isIn, timeout: 300, onEntered: this.onEntered }, (state) => (React.createElement("div", Object.assign({ ref: forwardedRef, style: Object.assign(Object.assign({}, defaultStyle), transitionStyles[state]) }, others),
            React.createElement(ToastSC, { inline: inline },
                contentRow,
                actionRow)))));
    }
}
Toast.propTypes = {
    message: PropTypes.string.isRequired,
    action: PropTypes.string,
    onAction: PropTypes.func,
    inline: PropTypes.bool,
    type: PropTypes.oneOf(['success', 'alert', 'info']),
    icon: PropTypes.element,
    forwardedRef: PropTypes.any
};
Toast.defaultProps = {
    action: null,
    onAction: null,
    inline: false,
    icon: null,
    type: 'success',
    forwardedRef: null
};
const ToastWithTheme = withTheme(Toast);
ToastWithTheme.displayName = 'Toast';
export { Toast as ToastRootComp };
export default withForwardedRef(ToastWithTheme);
//# sourceMappingURL=Toast.js.map